import {Injectable} from '@angular/core';
import {defer, NEVER} from 'rxjs';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {LoaderComponent} from '../components/loader/loader.component';
import {finalize, share} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    private overlayRef: OverlayRef | undefined = undefined;


    constructor(private readonly overlay: Overlay) {
    }

    public readonly spinner = defer(() => {
        this.show();
        return NEVER.pipe(
            finalize(() => {
                this.hide();
            })
        );
    }).pipe(share());

    private show(): void {
        Promise.resolve(null).then(() => {
            this.overlayRef = this.overlay.create({
                positionStrategy: this.overlay
                    .position()
                    .global()
                    .centerHorizontally()
                    .centerVertically(),
                hasBackdrop: true,
            });
            this.overlayRef.attach(new ComponentPortal(LoaderComponent));
        });
    }

    private hide(): void {
        if (this.overlayRef) {
            this.overlayRef.detach();
            this.overlayRef = undefined;
        }
    }
}
